/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Utils').factory('FileExtension', [
    function() {
        var fileExtensionRegExp = /.+\.([^\.]+)$/;
        return {
            getExtension: function(filename) {
                var ext = fileExtensionRegExp.exec(filename.trim());

                return ext != null ? ext[1].toLowerCase() : '';
            }
        };
    }
]);
